import subDays from 'date-fns/subDays';

// Default range the TimePicker shows and reports when its host doesn't pass dates, and on "Reset dates".
export const TIME_PICKER_DEFAULT_DAYS = 3;

// Calendar days (not 72h) so the start keeps the same wall-clock time across DST changes.
// One shared "now" so start and end can't straddle a minute boundary.
export const getTimePickerDefaultRange = () => {
  const endDate = new Date();
  endDate.setSeconds(0, 0);
  return { startDate: subDays(endDate, TIME_PICKER_DEFAULT_DAYS), endDate };
};
